export default __webpack_public_path__ + "static/break1.1_Granddad-aa7b4b9d5c59a56b58755fb42db1ece2.wav";